import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.3749 0.864877C8.15577 0.689572 7.8444 0.689572 7.62527 0.864877L0.958603 6.19821C0.699846 6.40522 0.657894 6.78279 0.864899 7.04155C1.07191 7.30031 1.44948 7.34226 1.70824 7.13525L2.66672 6.36846V14.6667H13.3334V6.36842L14.2919 7.13525C14.5507 7.34226 14.9283 7.30031 15.1353 7.04155C15.3423 6.78279 15.3003 6.40522 15.0416 6.19821L8.3749 0.864877Z",
		fill: "currentColor"
	})
});
export default SvgHomeFilled;
